import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyFieldPerformance } from './Pages';

export const DailyFieldPerformanceRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DailyFieldPerformance} />
    </Fragment>
)